import React from 'react'
import LayoutComponent from '../BaseScreen'

const TicketsScreen = () => {
  return (
    <LayoutComponent
      header={null} // Render your custom header component here
      content={<div>Tickets</div>} // Render your custom content component here
    />
  )
}

export default TicketsScreen
